import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
const VerticalContainer = styled.div `
  margin: -5px;
  > * {
    margin: 5px;
  }
`;
const Wrapper = styled.div `
  display: ${({ styled: { align } }) => (align ? 'flex' : 'inline-flex')};
  flex-wrap: ${({ styled: { noWrap } }) => !noWrap && 'wrap'};
  margin: ${({ styled: { spacer, vertical } }) => !spacer && !vertical && '-5px'};
  justify-content: ${({ styled: { align } }) => (align === 'right' ? 'flex-end' : align)};
  > * {
    margin: ${({ styled: { vertical } }) => !vertical && '5px'};
  }
  ${({ styled: { spacer, vertical } }) => spacer === 'top' &&
    css `
      margin: ${() => (vertical ? '15px 0 0' : '10px -5px -5px')};
    `};
  ${({ styled: { spacer, vertical } }) => spacer === 'bottom' &&
    css `
      margin: ${() => (vertical ? '0 0 15px' : '-5px -5px 10px')};
    `};
`;
const ButtonGroup = ({ noWrap, vertical, align, spacer, children, ...other }) => (_jsx(Wrapper, { ...other, styled: {
        noWrap,
        align,
        spacer,
        vertical,
    }, children: vertical ? _jsx(VerticalContainer, { children: children }) : children }));
export default ButtonGroup;
